import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { environment } from '../../../environment';
import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const ThirdPartyForm_LegalStatuses_QueryDocument = graphql(`
  query ThirdPartyForm_LegalStatuses_Query {
    findAllActiveLegalStatuses {
      _id
      inseeCode
      label
      aliases
      parentId
    }
  }
`);

export type ThirdPartyForm_LegalStatus = ResultOf<
  typeof ThirdPartyForm_LegalStatuses_QueryDocument
>['findAllActiveLegalStatuses'][number];

export const useLegalStatusesQuery = () =>
  useGraphQLQuery(ThirdPartyForm_LegalStatuses_QueryDocument, undefined, {
    gcTime: environment.referenceQueryGcTime,
    staleTime: environment.referenceQueryStaleTime,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
